import { hubspotClient } from '../http-client/hubspot-client';
import { apiConstants } from './apiConstants';

function formatCurrency(value) {
  return value
    .toLocaleString('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    })
    .split('.')[0];
}

function formatPercentage(value) {
  return `${value.toFixed(2)}%`;
}

const submitProspectFormContact = (
  cookie,
  email,
  firstName,
  lastName,
  phoneNumber,
  clubName,
  existingFlexiMembership
) => {
  const url = apiConstants.prospectForm;

  const entry = [
    { name: 'email', value: email },
    { name: 'firstname', value: firstName },
    { name: 'lastname', value: lastName },
    { name: 'phone', value: phoneNumber },
    { name: 'club_name', value: clubName },
    { name: 'club_has_an_existing_flexible_membership', value: existingFlexiMembership },
    { name: 'customer_type', value: 'B2B' },
  ];

  const communication = [
    {
      value: true,
      subscriptionTypeId: 999,
      text: 'I agree to receive marketing communications from PlayMoreGolf Company.',
    },
  ];
  const consent = {
    consent: {
      consentToProcess: true,
      text: 'I agree to allow PlayMoreGolf Company to store and process my personal data.',
      communications: communication,
    },
  };

  if (cookie !== null) {
    cookie = {
      hutk: cookie,
      pageUri: 'https://tools.playmore.golf/#/Prospect',
      pageName: 'Flexible Membership Profit Simulator Prospect',
    };
  } else {
    cookie = {
      pageUri: 'https://tools.playmore.golf/#/Prospect',
      pageName: 'Flexible Membership Profit Simulator Prospect',
    };
  }

  const body = { fields: entry, context: cookie, legalConsentOptions: consent };

  return hubspotClient.post(url, body).then((result) => result);
};

function getTotal(result, pmg, type) {
  let total = 0;
  const product = pmg ? result.Product2 : result.Product1;

  product.forEach((p) => {
    switch (type) {
      case 0:
        total += p.AvgProjectedNYRetention;
        break;
      case 1:
        total += p.AvgProjectedNYGrowth;
        break;
      case 2:
        total += p.AvgProjectedNYAwayRevenue;
        break;
      case 3:
        total += p.AvgProjectedTotalCosts;
        break;
      case 4:
        total += p.ProjectedProfit.Mean;
        break;
      case 5:
        total += p.AvgProjectedNYTotalRevenue;
        break;
      default:
        total += 0;
        break;
    }
  });

  return formatCurrency(total);
}

function isProfitable(result) {
  let profit = 0;
  const product = result.Product2;

  product.forEach((p) => {
    profit += p.ProjectedProfit.Mean;
  });

  return profit > 0;
}

function isMoreProfitable(result) {
  let profitPMG = 0;
  const productPMG = result.Product2;

  productPMG.forEach((p) => {
    profitPMG += p.ProjectedProfit.Mean;
  });

  let profit = 0;
  const product = result.Product1;

  product.forEach((p) => {
    profit += p.ProjectedProfit.Mean;
  });

  return profitPMG > profit;
}

const submitProspectSimulatorSubmission = (
  email,
  existingFlexiMembership,
  flexiMembers,
  digitalSpend,
  otherSpend,
  softwareCost,
  flexiMembershipPrice,
  fullMembershipPrice,
  link,
  result
) => {
  const url = apiConstants.prospectSimulatorSubmission;

  let entry;
  if (existingFlexiMembership) {
    entry = [
      { name: 'current_flexi_joiners', value: flexiMembers },
      { name: 'monthly_marketing_spend', value: digitalSpend },
      { name: 'monthly_other_marketing_costs', value: otherSpend },
      { name: 'current_membership_management_software_cost', value: softwareCost },
      { name: 'average_membership_retention', value: getTotal(result, false, 0) },
      { name: 'pmg_average_membership_retention', value: getTotal(result, true, 0) },
      { name: 'average_membership_growth', value: getTotal(result, false, 1) },
      { name: 'pmg_average_membership_growth', value: getTotal(result, true, 1) },
      { name: 'average_flexi_revenue', value: getTotal(result, false, 2) },
      { name: 'pmg_average_flexi_revenue', value: getTotal(result, true, 2) },
      { name: 'average_total_cost', value: getTotal(result, false, 3) },
      { name: 'pmg_average_total_cost', value: getTotal(result, true, 3) },
      { name: 'average_total_profit', value: getTotal(result, true, 4) },
      { name: 'pmg_average_total_profit', value: getTotal(result, true, 4) },
      { name: 'pmg_average_total_revenue', value: getTotal(result, true, 5) },
      { name: 'pmg_product_is_profitable', value: isProfitable(result) },
      { name: 'pmg_product_is_more_profitable', value: isMoreProfitable(result) },
    ];
  } else {
    entry = [
      { name: 'current_flexi_joiners', value: flexiMembers },
      { name: 'monthly_marketing_spend', value: digitalSpend },
      { name: 'monthly_other_marketing_costs', value: otherSpend },
      { name: 'current_membership_management_software_cost', value: softwareCost },
      { name: 'full_7_day_membership_price', value: fullMembershipPrice },
      { name: 'average_membership_retention', value: getTotal(result, false, 0) },
      { name: 'pmg_average_membership_retention', value: getTotal(result, true, 0) },
      { name: 'average_membership_growth', value: getTotal(result, false, 1) },
      { name: 'pmg_average_membership_growth', value: getTotal(result, true, 1) },
      { name: 'average_flexi_revenue', value: getTotal(result, false, 2) },
      { name: 'pmg_average_flexi_revenue', value: getTotal(result, true, 2) },
      { name: 'average_total_cost', value: getTotal(result, false, 3) },
      { name: 'pmg_average_total_cost', value: getTotal(result, true, 3) },
      { name: 'average_total_profit', value: getTotal(result, true, 4) },
      { name: 'pmg_average_total_profit', value: getTotal(result, true, 4) },
      { name: 'pmg_average_total_revenue', value: getTotal(result, true, 5) },
      { name: 'pmg_product_is_profitable', value: isProfitable(result) },
      { name: 'pmg_product_is_more_profitable', value: isMoreProfitable(result) },
    ];
  }

  if (email !== null) {
    entry.push({ name: 'email', value: email });
  }

  const communication = [
    {
      value: true,
      subscriptionTypeId: 999,
      text: 'I agree to receive marketing communications from PlayMoreGolf Company.',
    },
  ];
  const consent = {
    consent: {
      consentToProcess: true,
      text: 'I agree to allow PlayMoreGolf Company to store and process my personal data.',
      communications: communication,
    },
  };

  let cookie = getHubspotCookie();
  if (cookie !== undefined) {
    cookie = {
      hutk: cookie,
      pageUri: encodeURI(link),
      pageName: 'Flexible Membership Profit Simulator',
    };
  } else {
    cookie = { pageUri: encodeURI(link), pageName: 'Flexible Membership Profit Simulator' };
  }

  const body = { fields: entry, context: cookie, legalConsentOptions: consent };

  return hubspotClient.post(url, body).then((result) => result);
};

function getHubspotCookie() {
  let hutkId;
  const value = `; ${document.cookie}`;
  const parts = value.split('; ' + 'hubspotutk' + '=');
  if (parts.length === 2) {
    return (hutkId = parts.pop().split(';').shift());
  }
  return undefined;
}

const submitForm = (
  data,
  hutkId,
  licenseFee,
  currentFlexiJoiners,
  fullMemberCost,
  monthlyMarketingSpend,
  monthlySocialSpend,
  employeeHourlyCost,
  packageCostProportion
) => {
  const url = apiConstants.simulatorForm;

  const entry = [
    { name: 'average_total_cost', value: formatCurrency(data.Product1.AvgProjectedTotalCosts) },
    { name: 'pmg_average_total_cost', value: formatCurrency(data.Product2.AvgProjectedTotalCosts) },

    {
      name: 'average_total_revenue',
      value: formatCurrency(data.Product1.AvgProjectedNYTotalRevenue),
    },
    {
      name: 'pmg_average_total_revenue',
      value: formatCurrency(data.Product2.AvgProjectedNYTotalRevenue),
    },

    { name: 'average_total_profit', value: formatCurrency(data.Product1.ProjectedProfit.Mean) },
    { name: 'pmg_average_total_profit', value: formatCurrency(data.Product2.ProjectedProfit.Mean) },

    { name: 'maximum_fixed_cost', value: formatCurrency(data.Product1.ProjectedFixedCosts.Max) },
    { name: 'average_fixed_cost', value: formatCurrency(data.Product1.ProjectedFixedCosts.Mean) },
    { name: 'minimum_fixed_cost', value: formatCurrency(data.Product1.ProjectedFixedCosts.Min) },

    {
      name: 'pmg_maximum_fixed_cost',
      value: formatCurrency(data.Product2.ProjectedFixedCosts.Max),
    },
    {
      name: 'pmg_average_fixed_cost',
      value: formatCurrency(data.Product2.ProjectedFixedCosts.Mean),
    },
    {
      name: 'pmg_minimum_fixed_cost',
      value: formatCurrency(data.Product2.ProjectedFixedCosts.Min),
    },

    { name: 'maximum_profit', value: formatCurrency(data.Product1.ProjectedProfit.Max) },
    { name: 'average_profit', value: formatCurrency(data.Product1.ProjectedProfit.Mean) },
    { name: 'minimum_profit', value: formatCurrency(data.Product1.ProjectedProfit.Min) },
    { name: 'risk_of_loss', value: formatPercentage(data.Product1.ProjectedProfit.RiskOfLoss) },

    { name: 'pmg_maximum_profit', value: formatCurrency(data.Product2.ProjectedProfit.Max) },
    { name: 'pmg_average_profit', value: formatCurrency(data.Product2.ProjectedProfit.Mean) },
    { name: 'pmg_minimum_profit', value: formatCurrency(data.Product2.ProjectedProfit.Min) },
    { name: 'pmg_risk_of_loss', value: formatPercentage(data.Product2.ProjectedProfit.RiskOfLoss) },

    { name: 'maximum_roi', value: formatPercentage(data.Product1.ProjectedROI.Max * 100) },
    { name: 'average_roi', value: formatPercentage(data.Product1.ProjectedROI.Mean * 100) },
    { name: 'minimum_roi', value: formatPercentage(data.Product1.ProjectedROI.Min * 100) },

    { name: 'pmg_maximum_roi', value: formatPercentage(data.Product2.ProjectedROI.Max * 100) },
    { name: 'pmg_average_roi', value: formatPercentage(data.Product2.ProjectedROI.Mean * 100) },
    { name: 'pmg_minimum_roi', value: formatPercentage(data.Product2.ProjectedROI.Min * 100) },

    { name: 'license_fee_cost', value: licenseFee },
    { name: 'current_flexi_joiners', value: currentFlexiJoiners },
    { name: 'full_member_cost', value: fullMemberCost },
    { name: 'monthly_marketing_spend', value: monthlyMarketingSpend },
    { name: 'monthly_social_spend', value: monthlySocialSpend },
    { name: 'employee_hourly_cost', value: employeeHourlyCost },
    { name: 'flexible_package_cost_proportion', value: packageCostProportion },
  ];
  const communication = [
    {
      value: true,
      subscriptionTypeId: 999,
      text: 'I agree to receive marketing communications from PlayMoreGolf Company.',
    },
  ];
  const consent = {
    consent: {
      consentToProcess: true,
      text: 'I agree to allow PlayMoreGolf Company to store and process my personal data.',
      communications: communication,
    },
  };

  let cookie;
  if (hutkId !== null) {
    cookie = {
      hutk: hutkId,
      pageUri: 'https://tools.playmore.golf/PlatformCompare/',
      pageName: 'Membership Platform Simulator',
    };
  } else {
    cookie = {
      pageUri: 'https://tools.playmore.golf/PlatformCompare/',
      pageName: 'Membership Platform Simulator',
    };
  }

  const body = { fields: entry, context: cookie, legalConsentOptions: consent };

  return hubspotClient.post(url, body).then((result) => result);
};

// const submitForm = (hutkId, firstname, lastname, email, phonenumber, selected_home_club, window) => {
//   const url = apiConstants.registerForm;

//   const entry = [{ name: 'firstname', value: firstname }, { name: 'lastname', value: lastname }, { name: 'email', value: email }, { name: 'phone', value: phonenumber }, { name: 'preferred_home_club', value: selected_home_club }];
//   const communication = [{ value: true, subscriptionTypeId: 999, text: 'I agree to receive marketing communications from PlayMoreGolf Company.' }];
//   const consent = { consent: { consentToProcess: true, text: 'I agree to allow PlayMoreGolf Company to store and process my personal data.', communications: communication } };
//   const cookie = { hutk: hutkId, pageUri: window, pageName: 'PlayMoreGolf Club Page' };
//   const body = { fields: entry, context: cookie, legalConsentOptions: consent };

//   return hubspotClient.post(url, body).then(result => result);
// };

export { submitForm, submitProspectFormContact, submitProspectSimulatorSubmission };
